import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta17 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-17/utils-consultaSeguimentoPergunta17'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { isUndefinedOrNull } from 'util/checks'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta17 } from './converter-HistoricoMchatPergunta17'

interface HistoricoMChatRfPergunta17Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta17 = (props: Readonly<HistoricoMChatRfPergunta17Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta17(aplicacoes)
  if (converted === null) return null

  const { header, perguntas, model } = converted
  if (isUndefinedOrNull(header)) return null

  const resultado = calculateResultadoPergunta17(model)
  const hasPerguntas = perguntas.length > 0

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='17'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta='“Ele...”'
      />
      {hasPerguntas && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
